module.exports = __webpack_public_path__ + "static/media/scythe.77d4813f.svg";